"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contractInputFetchData = exports.contractInputName = void 0;
const types_1 = require("@framework/types");
const types_2 = require("../../../../../../types");
exports.contractInputName = {
    [types_2.ServiceType.ADMIN]: "template.contractId",
    [types_2.ServiceType.OFFICE]: "contractId",
};
const baseFetchData = {
    contractModule: [types_1.ModuleType.MYSTERY],
    contractStatus: [types_1.ContractStatus.ACTIVE, types_1.ContractStatus.NEW],
};
exports.contractInputFetchData = {
    [types_2.ServiceType.ADMIN]: baseFetchData,
    [types_2.ServiceType.OFFICE]: {
        ...baseFetchData,
        contractType: [types_1.TokenType.ERC721],
    },
};
//# sourceMappingURL=schemas.js.map